var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('a',{staticClass:"btn btn-lg",attrs:{"href":_vm.link,"id":"upgrade-button","data-testid":"upgrade-button"}},[_vm._v("\n  Upgrade\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }